import React from 'react';

import { makeMuiStyles } from '@styles';
import clsx from 'clsx';

const useStyles = makeMuiStyles((theme, common) => ({
  container: {
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    flex: 1,
  },
  inner: {
    ...common.flexColumn,
    width: '100%',
    maxWidth: '1600px',
    margin: '0 auto',
    flex: 1,
    padding: '0 1rem',
    paddingBottom: '1rem',
  },
}));

export interface ContainerProps {}

export const Container: React.FC<React.PropsWithChildren<ContainerProps>> = (props) => {
  const classes = useStyles();
  const { children } = props;

  return (
    <div className={clsx(classes.container)}>
      <div className={clsx(classes.inner)}>{children}</div>
    </div>
  );
};
